module.exports = __webpack_public_path__ + "static/media/downArrowIconLight.027226f4.svg";